import { render, staticRenderFns } from "./iosSwitch.vue?vue&type=template&id=9251dcc2&scoped=true&"
import script from "./iosSwitch.vue?vue&type=script&lang=js&"
export * from "./iosSwitch.vue?vue&type=script&lang=js&"
import style0 from "./iosSwitch.vue?vue&type=style&index=0&id=9251dcc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9251dcc2",
  null
  
)

export default component.exports